import { Link } from '@farol-ds/react'
import { ReactNode } from 'react'

export function renderErrorMessage(message: string | ReactNode | (() => ReactNode)): ReactNode {
  if (typeof message === 'string') {
    return message
  }
  if (typeof message === 'function') {
    return message()
  }
  return message
}

// TODO: Move this method to be close to where is meant to be used. @pjonatansr
export function renderCpfNotVerifiedMessage(): ReactNode {
  return (
    <>
      Revise as informações fornecidas ou entre em{' '}
      <Link href="https://suporte.jusbrasil.com.br/hc/pt-br/requests/new" target="_blank">
        contato com o suporte
      </Link>
      .
    </>
  )
}

// TODO: Move this method to be close to where is meant to be used. @pjonatansr
export function renderSSOErrorMessage(): ReactNode {
  return (
    <>
      É possível que seu perfil já tenha uma assinatura vigente no Jusbrasil.
      <br />
      Para esse e outros casos, consulte a Central de Ajuda. Lá você encontra mais detalhes e um
      canal de suporte exclusivo para a parceria com o CNJ.
    </>
  )
}
